var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-input",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.userIds,
              expression: "!userIds"
            }
          ],
          staticClass: "jvxe-select-input",
          attrs: {
            placeholder: "请选择用户",
            readOnly: "",
            disabled: _vm.componentDisabled
          },
          on: { click: _vm.openSelect },
          model: {
            value: _vm.userNames,
            callback: function($$v) {
              _vm.userNames = $$v
            },
            expression: "userNames"
          }
        },
        [
          _c("a-icon", {
            attrs: { slot: "prefix", type: "user", title: "用户选择控件" },
            slot: "prefix"
          })
        ],
        1
      ),
      _c("j-select-user-by-dep-modal", {
        ref: "selectModal",
        attrs: {
          "modal-width": _vm.modalWidth,
          multi: _vm.multi,
          "user-ids": _vm.userIds
        },
        on: { ok: _vm.selectOK, initComp: _vm.initComp }
      }),
      _vm.userIds
        ? _c(
            "span",
            {
              staticStyle: {
                display: "inline-block",
                height: "100%",
                "padding-left": "14px"
              }
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    display: "inline-block",
                    "vertical-align": "middle"
                  },
                  on: { click: _vm.openSelect }
                },
                [_vm._v(_vm._s(_vm.userNames))]
              ),
              _c("a-icon", {
                staticStyle: {
                  "margin-left": "5px",
                  "vertical-align": "middle"
                },
                attrs: { type: "close-circle", title: "清空" },
                on: { click: _vm.handleEmpty }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }